<template>
  <Modal
    ref="userSettingsModal"
    :show-footer="false"
    position="center"
    @hide="hideModal"
  >
    <template v-if="user?.role !== Role.READ_ONLY" #activator="{ show }">
      <div
        class="font-medium text-dark-neutral-500 text-base hover:bg-light-neutral-300 px-4 py-1 pt-2"
      >
        <button class="py-2 tracking-wide w-full flex gap-2" @click="show">
          <Cog6ToothIcon class="size-6" />
          Settings
        </button>
      </div>
    </template>

    <template #header="{ hide }">
      <p
        class="text-primary text-lg font-semibold capitalize text-center flex gap-2 items-center"
      >
        Settings
      </p>
      <button
        class="bg-light-neutral-500 rounded-full h-[30px] w-[30px] flex items-center justify-center"
        @click="hide"
      >
        <XIcon class="size-4 stroke-2 text-mid-neutral-500" />
      </button>
    </template>

    <template #content>
      <div class="w-full space-y-4">
        <Tabs :tabs="tabs" :style="2" :tab="activeStep">
          <template #tab-content-1>
            <ProfileUserSettings />
          </template>
          <template #tab-content-2>
            <GeneralUserSettings />
          </template>
          <template #tab-content-3>
            <SecurityUserSettings />
          </template>
        </Tabs>
      </div>
    </template>
  </Modal>
</template>
<script setup lang="ts">
import Tabs from '@app/components/Global/Tabs/Tabs.vue'
import GeneralUserSettings from './General.vue'
import SecurityUserSettings from './Security.vue'
import ProfileUserSettings from './Profile.vue'
import Modal from '@app/components/Global/Modal/Modal.vue'
import { nextTick, useTemplateRef, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { injectStrict } from '@app/utils/injectStrict'
import { AuthKey } from '@app/injectionKeys'
import { Role } from '@core/domain/types/role.type'
import { Cog6ToothIcon } from '@heroicons/vue/24/solid'
import XIcon from '@app/components/Icons/XIcon.vue'

const { user } = injectStrict(AuthKey)
const activeStep = defineModel<number>({ default: 1 })

const tabs = [
  {
    number: 1,
    title: 'Profile',
  },
  {
    number: 2,
    title: 'General',
  },
  {
    number: 3,
    title: 'Security',
  },
]

const route = useRoute()
const userSettingsModal = useTemplateRef('userSettingsModal')
watch(
  () => route.query,
  async () => {
    if (route.query['reset-password']) {
      activeStep.value = 3
      await nextTick()
      userSettingsModal?.value?.show()
    }
  },
  { immediate: true },
)
const router = useRouter()
function hideModal() {
  router.replace({ query: { ...route.query, 'reset-password': undefined } })
}
</script>
